import {combineReducers} from 'redux';

import contractsList from './contracts-list';
import createContract from './create-contract';

export const eContractsReducer = combineReducers({
    createContract,
    contractsList,
});